import { useEffect, useState } from "react";
import useDevice from "../../utils/hooks/useDevice";
import { Icon } from "../Icon";
import { displayMoney } from "../../utils/displayMoney";
import { addedVariantsLabelColor } from "../AddVariant/util";

type Props = {
  preCart: CartProduct[];
  removeItem: (id: string) => void;
};

const AddedVariants: React.FC<Props> = ({ preCart, removeItem }) => {
  const { width } = useDevice();
  const [isSolid, setIsSolid] = useState<boolean>(false);
  useEffect(() => {
    preCart[0] &&
      (preCart[0].department == "chain" || "brazalete") &&
      !preCart[0].category.includes("pendant") &&
      !preCart[0].category.includes("rock") &&
      !preCart[0].category.includes("hollow") &&
      !preCart[0].category.includes("hoop") &&
      !preCart[0].category.includes("finding") &&
      !preCart[0].isCustom &&
      setIsSolid(true);
  }, []);

  return (
    <>
      {preCart.length > 0 && (
        <section className="itemDetail__data__precart__container">
          <div className="itemDetail__data__precart__titles">
            <p className="itemDetail__data__text">Variantes agregadas</p>
            <div className="itemDetail__data__precart__info">
              <p>Peso U.</p>
              <p>Peso</p>
              <p>Hechura</p>
            </div>
          </div>
          {preCart.map((el) => {
            return (
              <div className="itemDetail__data__precart" key={el._id}>
                <div className="itemDetail__data__precart__item">
                  <Icon iconName="tick_icon" />
                  <p>
                    {width > 1200 ? (
                      <span
                        className={`item_color ${
                          el.color === "rojo" && `item_color_red`
                        } ${el.color === "amarillo" && `item_color_yellow`} ${
                          el.color === "blanco" && `item_color_white`
                        } ${el.color === "plata" && `item_color_white`}`}
                      ></span>
                    ) : null}
                    {addedVariantsLabelColor(el.color)}
                  </p>
                  <p>
                    {(el.department != "brazalete" &&
                      el.department != "chain") ||
                    !isSolid
                      ? "Esp.: "
                      : "Hilo: "}{" "}
                    {el.gauge}
                  </p>
                  <p>
                    {(el.department != "brazalete" &&
                      el.department != "chain") ||
                    !isSolid
                      ? "Medidas: "
                      : "Largo: "}
                    {(el.department != "brazalete" &&
                      el.department != "chain") ||
                    !isSolid
                      ? el.length
                      : el.length + "cm"}
                  </p>
                  <p>Cantidad: {el.quantity}</p>
                </div>
                <div className="itemDetail__data__precart__weights">
                  <p>{Number(el.weight.replace(",", "."))}gr</p>
                  <p>
                    {(
                      Number(el.weight.replace(",", ".")) * el.quantity
                    ).toFixed(2)}
                    gr
                  </p>
                  <p>
                    {el.manufacturValue == 0
                      ? "A consultar"
                      : displayMoney(el.manufacturValue * el.quantity)}
                  </p>
                  <button
                    className="itemDetail__data__selector__delete"
                    type={"button"}
                    onClick={() => removeItem(el._id || "")}
                  >
                    <Icon iconName="trash_icon" />
                  </button>
                </div>
              </div>
            );
          })}
        </section>
      )}
    </>
  );
};

export default AddedVariants;
